import { Component, inject } from '@angular/core';
import { LoadingService } from '../../shared/service/loading.service';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-loader',
  imports: [CommonModule],
  templateUrl: './loader.component.html',
  styleUrl: './loader.component.css'
})
export class LoaderComponent {
  loading$ = inject(LoadingService).loading$;
}
